import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "config/Headers";
import { CREATE_PAIYA_GIFT_URL, GET_PAIYA_GIFT_DETAILS_URL } from "config/Url";
import { IPaiyaGift } from "interfaces/Index";
import { normalizePaiyaGiftsList } from "normalizer/PaiyaGiftNormalizer";
import { normalizeCatchErrors } from "utils/errorUtils";

export const createPaiyaGiftApiCall = (payload: any) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_PAIYA_GIFT_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        // console.log("errors here in source", error);
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPaiyaGiftsApiCall = (searchKey: string, giftType: string) =>
  new Promise<Array<IPaiyaGift>>((resolve, reject) => {
    const URL = GET_PAIYA_GIFT_DETAILS_URL;

    let requestConfig: any = getAuthOptions();
    requestConfig.params = {
      searchKey: searchKey,
      giftType: giftType,
    };
    axios
      .get(URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizePaiyaGiftsList(data));
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
